module.exports = __webpack_public_path__ + "img/icon_video2.a0936f12.svg";